import React, { Component } from 'react';
// import PropTypes from 'prop-types';

import { privacyModalContent } from '../../utils/commonFormsConfig';

class PrivacyPolicy extends Component {
	
	render() {
		
		return <div className='container-fluid'>
            <div className="row">
                <div className="col-12 col-md-10 offset-md-1">
                    <h1>{privacyModalContent.title}</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-10 offset-md-1 mb-4 font-italic font-weight-300">
                    {privacyModalContent.disclaimer}
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-10 offset-md-1">
                    {privacyModalContent.content}
                </div>
            </div>
		</div>;
	}
}

PrivacyPolicy.propTypes = {
};

export default PrivacyPolicy;
